/**
 * A figure's last fourteen days as a small line (16 Oct): the days drawn to
 * one scale, a soft area under the line, and the last day marked. Its colour
 * is the figure's own tone. Decorative: the figure and its trend say the
 * numbers in words, so it is hidden from screen readers.
 */
export function Sparkline({ values, width = 64, height = 20, className }: { values: readonly number[]; width?: number; height?: number; className?: string }) {
  if (values.length < 2) return null;
  const max = Math.max(1, ...values);
  // Room for the end dot and the line's own width at the edges.
  const pad = 2.5;
  const x = (index: number) => pad + (index / (values.length - 1)) * (width - pad * 2);
  const y = (value: number) => height - pad - (value / max) * (height - pad * 2);
  const points = values.map((value, index) => `${x(index).toFixed(1)},${y(value).toFixed(1)}`);
  const line = `M${points.join(' L')}`;
  const area = `${line} L${x(values.length - 1).toFixed(1)},${height - pad} L${x(0).toFixed(1)},${height - pad} Z`;
  const last = values.length - 1;
  return (
    <svg className={className} width={width} height={height} viewBox={`0 0 ${width} ${height}`} aria-hidden="true" data-testid="dash-sparkline" focusable="false">
      <path d={area} fill="var(--tone)" fillOpacity={0.12} stroke="none" />
      <path d={line} fill="none" stroke="var(--tone)" strokeWidth={1.5} strokeLinejoin="round" strokeLinecap="round" />
      <circle cx={x(last)} cy={y(values[last]!)} r={2.25} fill="var(--tone)" />
    </svg>
  );
}
